import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { FilterAccesoModel } from 'src/app/models/acceso/FilterAccesoModel';
import { VigilanciaAccesoPersonalResult } from 'src/app/models/acceso/VigilanciaAccesoPersonalResult';
import { AccesoEstado, ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { IFilterAccesoModel } from 'src/app/models/interfaces/accesos/IFilterAccesoModel';
import { IVigilanciaAccesoPersonalResult } from 'src/app/models/interfaces/accesos/IVigilanciaAccesoPersonalResult';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { AccesoPersonaService } from 'src/app/services/acceso-personal/acceso-persona.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-vigilante-accesos-lista',
  templateUrl: './vigilante-accesos-lista.component.html',
  styleUrls: ['./vigilante-accesos-lista.component.css'],
})
export class VigilanteAccesosListaComponent implements OnInit {
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  modelFilter: IFilterAccesoModel;
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  modelListaAccesoPersonal: IVigilanciaAccesoPersonalResult[];
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  resultsLength = 0;
  currentPage = 0;

  @ViewChild('paginator') paginator!: MatPaginator;
  
  displayedColumns: string[] = [
    'codigo',  
    'compania',
    'trabajador',
    'nroDocumentoIdentidad',
    'sede',
    'solicitante',
    'contratista',
    'subcontratista',
    'fechaAprobacion',
    'estado',
    'fechaInicio',
    'fechaFin',
    'acciones',
  ];

  constructor(
    private sedeService: SedeService,
    private parametroService: ParametroService,
    private accesoPersonalService: AccesoPersonaService,
    private storage: StorageService
  ) {
    this.modelFilter = new FilterAccesoModel();
    this.modelFilter.pageSize = 30;
    this.modelFilter.estados = [];//AccesoEstado.AUTORIZADO, AccesoEstado.NO_AUTORIZADO, AccesoEstado.BLOQUEADO, AccesoEstado.VENCIDO];
    this.modelListaAccesoPersonal = new Array<VigilanciaAccesoPersonalResult>();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.modelFilter.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.parametroService.getDetalles(ParametrosMaestro.ESTADO_ACCESO_PERSONA).subscribe((data) => {
      this.listaEstados = data.items.filter(result => result.idParametroDetalle != AccesoEstado.PENDIENTE);
    });
    
    this.companiaChanged();

    this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.modelFilter.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.modelFilter.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  addDays(currentDate: Date, days: number): Date {
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  search(): void {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.accesoPersonalService
      .getListVigilante(this.modelFilter)
      .subscribe((data: SearchResultModel<IVigilanciaAccesoPersonalResult[]>) => {
        this.modelListaAccesoPersonal = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    // console.log(event);
    //   if(event.pageIndex === this.pageIndex + 1){
    //      this.lowValue = this.lowValue + this.pageSize;
    //      this.highValue =  this.highValue + this.pageSize;
    //     }
    //  else if(event.pageIndex === this.pageIndex - 1){
    //     this.lowValue = this.lowValue - this.pageSize;
    //     this.highValue =  this.highValue - this.pageSize;
    //    }
    //     this.pageIndex = event.pageIndex;
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.accesoPersonalService
      .getListVigilante(this.modelFilter)
      .subscribe(
        (data: SearchResultModel<IVigilanciaAccesoPersonalResult[]>) => {
          this.modelListaAccesoPersonal = data.items;
          this.resultsLength = data.total;
        }
      );
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }  

  export() {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.accesoPersonalService.getListVigilanteToExport(this.modelFilter).subscribe(
      (data) => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `accesos-personal-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      },
      (error) => {
        //  this.isImageLoading = false;
        //  console.log(error);
      }
    );
  }
}
